var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSunreact = function SvgSunreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 240 240"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 1",
    d: "m130.5 0-2.58 75.093 23.257-71.447L135.6 77.15l35.312-66.322L142.8 80.509l46.292-59.183-39.781 63.742 55.866-50.245-50.245 55.866 63.742-39.781L159.491 97.2l69.682-28.108L162.85 104.4l73.5-15.581-71.447 23.259L240 109.5 165.6 120l74.4 10.5-75.093-2.58 71.447 23.259L162.85 135.6l66.322 35.312-69.681-28.112 59.183 46.292-63.742-39.781 50.245 55.866-55.866-50.245 39.781 63.742-46.292-59.183 28.108 69.682L135.6 162.85l15.581 73.5-23.259-71.447L130.5 240 120 165.6 109.5 240l2.58-75.093-23.257 71.447 15.581-73.5-35.312 66.318L97.2 159.491l-46.292 59.183 39.781-63.742-55.866 50.245 50.245-55.866-63.742 39.781L80.509 142.8l-69.681 28.108L77.15 135.6l-73.5 15.581 71.447-23.259L0 130.5 74.4 120 0 109.5l75.093 2.58L3.646 88.823 77.15 104.4 10.828 69.092 80.509 97.2 21.326 50.908l63.742 39.781-50.245-55.866 55.866 50.245-39.781-63.742L97.2 80.509 69.092 10.828 104.4 77.15 88.823 3.646l23.259 71.447L109.5 0 120 74.4Z",
    opacity: 0.24
  })));
};

export default SvgSunreact;